import React from 'react';
import { Link } from 'react-router-dom';
import FooterBottom from './FooterBottom';


import Newsletter from '../../Common/Newsletter';

import footerLogo1 from '../../../assets/img/logo/logo.png';

const Footer = (props) => {
    const { footerLogo, footerClass } = props;
    return (
        <footer className={footerClass ? footerClass : 'rs-footer'}>
            <div className="footer-top">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-3 col-lg-3 col-md-4">
                            <div className="footer-logo">
                                <Link to="/" ><img src={footerLogo ? footerLogo : footerLogo1} alt="Logo" /></Link>
                            </div>
                            <div className="textwidget pb-30">
                                <p>We ensure that you have high-quality, scalable, and reliable software solutions — and the AI-powered automation to go with them — helping you achieve your business goals.</p>
                            </div>
                            {/* <ul className="footer-social md-mb-30">
                                <li>
                                    <Link to="#"><i className="fa fa-facebook"></i></Link>
                                </li>
                                <li>
                                    <Link to="#"><i className="fa fa-twitter"></i></Link>
                                </li>
                                <li>
                                    <Link to="#"><i className="fa fa-pinterest"></i></Link>
                                </li>
                                <li>
                                    <Link to="#"><i className="fa fa-instagram"></i></Link>
                                </li>
                            </ul> */}
                        </div>
                        <div className="col-lg-3 col-md-12 col-sm-12 pl-44 md-pl-14 md-mb-30">
                            <h3 className="widget-title">IT Services</h3>
                            <ul className="site-map">
                                <li><Link to="/">Software Development</Link></li>
                                <li><Link to="/">Web Development</Link></li>
                                <li><Link to="/">Analytic Solutions</Link></li>
                                <li><Link to="/">Cloud and DevOps</Link></li>
                                <li><Link to="/">MVP Development</Link></li>
                                <li><Link to="/">Report Automation Solutions</Link></li>
                                <li><Link to="/">AI Workflow Automation</Link></li>
                                <li><Link to="/">AI Consulting &amp; Strategy</Link></li>
                            </ul>
                        </div>
                        <div className="col-lg-3 col-md-12 col-sm-12 md-mb-30">
                            <h3 className="widget-title">Contact Info</h3>
                            <ul className="address-widget">
                                <li>
                                    <i className="flaticon-location"></i>
                                    <div className="desc">Suite 5, 1 Faraday Rd. Padstow NSW 2211</div>
                                </li>
                                <li>
                                    <i className="flaticon-call"></i>
                                    <div className="desc">
                                        <Link to="#">0411 471 511</Link>
                                    </div>
                                </li>
                                <li>
                                    <i className="flaticon-email"></i>
                                    <div className="desc">
                                        <Link to="#">support@idlprojections.com</Link>
                                    </div>
                                </li>
                                
                            </ul>
                        </div>
                        <div className="col-lg-3 col-md-12 col-sm-12">
                            {/* <h3 className="widget-title">Newsletter</h3>
                            <p className="widget-desc">We denounce with righteous and in and dislike men who are so beguiled and demo realized.</p>
                            <p> */}
                                {/* newsletter-area-start */}
                                {/* <Newsletter /> */}
                                {/* newsletter-area-end */}
                            {/* </p> */}
                        </div>
                    </div>
                </div>
            </div>
            <FooterBottom />
        </footer>
    );
}

export default Footer;